import { render } from "./UpdateHeadofAgencyDialog.vue?vue&type=template&id=bde6b2da&scoped=true"
import script from "./UpdateHeadofAgencyDialog.vue?vue&type=script&lang=js"
export * from "./UpdateHeadofAgencyDialog.vue?vue&type=script&lang=js"

import "./UpdateHeadofAgencyDialog.vue?vue&type=style&index=0&id=bde6b2da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde6b2da"]])

export default __exports__